<div (click)="$event.preventDefault(); closeModal();"
    class="fixed inset-0 flex items-center justify-center bg-main-background bg-opacity-75 z-20 gap-4">
    <div class="w-full max-w-screen-md flex flex-row gap-1 justify-center overflow-y-auto" (click)="$event.stopPropagation()">
        <div class="flex min-w-full bg-white p-10 rounded-md text-center shadow-lg">
            <form (ngSubmit)="$event.preventDefault(); save();" #staffForm="ngForm"
                class="w-full flex flex-col items-center justify-start gap-4">
                <div class="w-full flex flex-row gap-8 items-center justify-between pb-4 border-b border-gray-200">
                    <h2 class="w-full oswald-font text-xl font-medium text-start whitespace-nowrap text-nside-orange-400">
                        {{ isEdit ? 'Edit Staff Member' : 'Add a Staff Member' }}
                    </h2>
                    <button class="p-1 rounded-full hover:bg-gray-100" (click)="$event.preventDefault(); closeModal();">
                        <lucide-icon [name]="icons.X" [size]="20" class="text-nside-gray-200"></lucide-icon>
                    </button>
                </div>

                <div class="w-full flex flex-col items-center justify-center gap-3 pb-4 border-b border-gray-200">
                    <!-- Staff Name : dropdown of contacts -->
                    <div class="w-full flex items-start gap-3 text-start">
                        <label class="w-56 shrink-0 pt-2 text-nside-gray-300">Staff Name:</label>
                        <div class="flex-1 min-w-0 flex flex-col">
                            <select name="staff_name" [(ngModel)]="staff.staff_name" required
                                class="w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded p-2">
                                <option [ngValue]="undefined" disabled>Select a staff member</option>
                                <option *ngFor="let contact of contactsList" [value]="contact.name">{{ contact.name }}</option>
                            </select>
                            <div class="w-full text-start italic text-xs text-red-500" *ngIf="staffForm.submitted && !staff.staff_name">This field is required.</div>
                        </div>
                    </div>
                    <div class="w-full flex items-center gap-3 text-start">
                        <label class="w-56 shrink-0 text-nside-gray-300">Primary Work Location:</label>
                        <input type="text" name="primary_work_location" [(ngModel)]="staff.primary_work_location"
                            class="flex-1 min-w-0 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded p-2" placeholder="Primary Work Location">
                    </div>
                    <div class="w-full flex items-start gap-3 text-start">
                        <label class="w-56 shrink-0 pt-2 text-nside-gray-300">Type of Assistance Required:</label>
                        <textarea name="type_of_assistance" [(ngModel)]="staff.type_of_assistance" rows="2"
                            class="flex-1 min-w-0 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded p-2" placeholder="Type of Assistance Required"></textarea>
                    </div>
                </div>

                <div class="w-full flex flex-row gap-2 items-center justify-end">
                    <button (click)="$event.preventDefault(); closeModal();"
                        class="px-4 py-1.5 w-20 rounded-md border border-nside-gray-400 oswald-font">Close</button>
                    <button type="submit"
                        class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                        [ngClass]="{
                            'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': !isValid,
                            'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': isValid
                        }" [disabled]="!isValid">Save</button>
                </div>
            </form>
        </div>
    </div>
</div>

<div *ngIf="loading">
    <spinner></spinner>
</div>
